import React from 'react';
  import { useFormContext, useController } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { Radio } from "./index";

const RadioGroup = ({ options, name, handleChange, getOptionValue, getOptionLabel, returnValueHowOption = false }) => {
  const { control } = useFormContext()
  const {
    field: { value, onChange, ref, ...inputProps },
    formState: { errors }
  } = useController({ name, control })

  const onChangeExtend = newValue => {
    let value;
    if(returnValueHowOption) {
      value = options.find(option => getOptionValue(option) === newValue)
    } else {
      value = newValue
    }
    onChange(value)
    if(handleChange) {
      handleChange(name, value)
    }
  }

  return (
    <>
      <ErrorMessage
        errors={errors}
        name={name}
        render={({ message }) => (
          <small className="text-danger">
            {message}
          </small>
        )}
      />
      {options.map(option => {
        return (
          <div key={getOptionValue(option)}>
            <Radio
              value={getOptionValue(option)}
              label={getOptionLabel(option)}
              onChange={onChangeExtend}
              checked={getOptionValue(option) === getOptionValue(value)}
              inputRef={ref}
              {...inputProps}
            />
          </div>
        );
      })}
    </>
  )
}

RadioGroup.defaultProps = {
  handleChange: () => {},
}

export default RadioGroup


